import React from 'react';
import {BusinessWorkOrderSystemPopup} from '../Constant/Constant';
import {connect} from 'react-redux';
import {setCurrentStep, setShowPopUp} from '../BusinessWorkOrderSystemSlice';
import WorkOrderDetails from './WorkOrderDetails';
import CloseFU from './CloseFU';
import GeneralMessagePopup from './GeneralMessagePopup';

const BusinessWOMainPopup = (props) => {
  let currentPopUp = () => {
    switch (props.businessWorkOrderSystem.currentPopUp) {
      case BusinessWorkOrderSystemPopup.WorkOrderData:
        return <WorkOrderDetails />;
      case BusinessWorkOrderSystemPopup.CloseFU:
        return <CloseFU />;
      case BusinessWorkOrderSystemPopup.GeneralMessage:
        return <GeneralMessagePopup />;
      default:
        break;
    }
  };

  return <div>{currentPopUp()}</div>;
};
const mapStateToProps = (state) => ({
  businessWorkOrderSystem: state.businessWorkOrderSystem,
});

const mapDispatchToProps = {setShowPopUp};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessWOMainPopup);
